export default __webpack_public_path__ + "static/media/SearchIcon.ece01184.svg";